import React, { useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography } from '@mui/material';
import { Box } from '@mui/system';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { Icon } from '@iconify/react';
import { useForm } from 'react-hook-form';
import useAuthUsers from '../../../../../hooks/useAuthUsers';
import { useSnackbar } from 'notistack';
import { LoadingButton } from '@mui/lab';

export default function DialogConfirmUpdate({ updateContrato, open, onClose }) {
  const { enqueueSnackbar } = useSnackbar();
  const { verifyUserNip } = useAuthUsers();
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    reset
  } = useForm();

  const handleClose = () => {
    onClose(false);
  };

  const onSubmit = async (dataForm) => {
    console.log(dataForm.nip);
    await updateContrato();
    reset();
    handleClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      {/* <DialogTitle id="alert-dialog-title">Titulo del dialogo</DialogTitle> */}
      <DialogContent>
        <Box component="form" onSubmit={handleSubmit(onSubmit)}>
          <Box marginBottom="15px">
            <TextField
              type="password"
              fullWidth
              {...register('nip', { required: true })}
              variant="outlined"
              label="NIP"
            />
            {errors.nip && (
              <Typography color="error" fontSize="13px">
                Ingrese su NIP
              </Typography>
            )}
          </Box>

          <LoadingButton loading={isSubmitting} fullWidth variant="contained" type="submit">
            Guardar
          </LoadingButton>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="inherit" startIcon={<Icon icon="eva:arrow-back-fill" />}>
          Atras
        </Button>
      </DialogActions>
    </Dialog>
  );
}
